import { useAuthStore } from 'stores/auth'

export default {
  path: '/',
  name: 'auth',
  redirect: { name: 'login' },
  component: () => import('layouts/AuthLayout.vue'),
  children: [
    {
      path: 'login',
      name: 'login',
      component: () => import('pages/auth/LoginPage.vue'),
      beforeEnter: (to, from, next) => {
        const authStore = useAuthStore()
        if (authStore.isAuthenticated) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  ],
}
